import * as React from "react";
import Input from "../Input-new/Input";
import SelectFirm from "../SelectFirm/SelectFirm";
import Dropdown from "../Dropdown/Dropdown";
import Checkbox from "../CheckboxNew/Checkbox";

const AgentInfo = ({
  data,
  handleChangeInput,
  handleChangeDropdown,
  viewMode,
  deleted,
  addNewItem,
  newFirm,
  isExists,
  handleParentDropdownChange,
  theme = 'white',
  typeDuplicate
}) => {
  function getCompanyZIP() {
    if (viewMode == true && typeof data.zip !== 'undefined' && data.zip != null && data.zip.length < 5) {
      data.zip = '0'.repeat(5 - data.zip.length) + data.zip
    }
    if (data.zip == null || data.zip == '00000' || data.zip == '') {
      data.zip = ''
    }
    return data.zip;
  }
  return (
    <div className="Agent-info">
      <div className="Agent-info_column">
      {(isExists) && <p className="errorText">{typeDuplicate ? typeDuplicate : " Given Agent Details Already Exists"}</p>}
        
        <div className="hotlist_name_section">
        <div className="Agent-info_column_hotlist_name_label">
            <label>First Name</label>
            <Checkbox 
                text="AthCap - Hot List"
                type={viewMode ? "uncheckable" : "checkable"}
                isSelected={data.hsc_hot_list === "1"} 
                handleClick={() => handleChangeInput("hsc_hot_list")} 
                name="hsc_hot_list"
            />

        </div>
        <Input
            className="Agent-info_column_item"
            required
            valueType="text"
            name="first_name"
            value={data.first_name}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          />
        </div>
        
        {/* <Input
          className="Agent-info_column_item"
          required
          valueType="text"
          name="first_name"
          label="First Name"
          value={data.first_name}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        /> */}
        <Input
          className="Agent-info_column_item"
          required
          valueType="text"
          name="last_name"
          label="Last Name"
          value={data.last_name}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Agent-info_column_item"
          valueType="phone"
          name="phone"
          label="Work Phone"
          value={data.phone}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Agent-info_column_item"
          required={data.contact_type && data.contact_type.includes("Team")}
          valueType="phone"
          name="cell_phone"
          label="Cell Phone"
          value={data.cell_phone}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Agent-info_column_item"
          required={data.contact_type && data.contact_type.includes("Team")}
          valueType="email"
          name="email"
          label="Email"
          value={data.email}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        {/* <SelectFirm
          className="Agent-info_column_item"
          value={data.firm}
          valueKey="firm"
          label="Company"
          data={data}
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
          withAddNew={true}
          addNewItem={addNewItem}
          newFirm={newFirm}
        /> */}
      </div>
      <div>
        <Input
          className="Agent-info_column_item"
          //name="COMPANY_ADDRESS"
          name="address"
          label="Address"
          //value={data.COMPANY_ADDRESS}
          value={data.address}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Agent-info_column_item"
          valueType="text"
          //name="CITY"
          name="city"
          label="CITY"
          //value={data.CITY}
          value={data.city}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />

        <Dropdown
          className="Agent-info_column_item"
          data={data}
          optionsType="states"
          optionKey="abbr"
          optionLabelKey="name"
          // value={data.STATE}
          // valueKey="STATE"
          value={data.state}
          valueKey="state"
          label="STATE"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Agent-info_column_item"
          //name="COMPANY_ZIP"
          name="zip"
          label="Zip"
          value={getCompanyZIP()}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Dropdown
          className="Agent-info_column_item"
          theme={theme}
          dropdownType='multiple'
          optionsType='contactType'
          value={Array.isArray(data.contact_type) ? data.contact_type.join(",") : data.contact_type || ""}
          valueKey='contact_type'
          // value={data.market}
          // valueKey='market'
          label='Contact Type'
          data={data}
          handleParentChange={handleParentDropdownChange}
          viewMode={viewMode}
          deleted={deleted}
        />
        {/* <Dropdown
          className="Agent-info_column_item"
          theme={theme}
          dropdownType='multiple'
          optionsType='contactType'
          value={Array.isArray(data.contact_type) ? data.contact_type.join(",") : data.contact_type || ""}
          valueKey='contact_type'
          // value={data.market}
          // valueKey='market'
          label='Type'
          data={data}
          handleParentChange={handleParentDropdownChange}
        /> */}
        {data.contact_type && (data.contact_type.includes("Lender")) ?
          <Input
            className="Agent-info_column_item"
            name="name"
            required
            label="Company"
            value={data.name}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          />
          : ""
        }
        {/* {data.contact_type && (data.contact_type.includes("Lender")) ?
          <Input
            className="Agent-info_column_item"
            required
            valueType="text"
            inputType="textarea"
            //name="notes"
            name="notes"
            label="Notes"
            //value={data.NOTES}
            value={data.notes}
            viewMode={viewMode}
            handleParentChange={handleChangeInput}
            deleted={deleted}
          /> : ""
        } */}
      </div>
    </div>
  );
};

export default AgentInfo;
